import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class ArchivingImagesService {
    constructor(private apiHttp: ApiHttp) {
    }

    public downloadLatestArchive(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/ClientPages/DownloadLatestArchive', data, messageService);
    }

    public archiveFolders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.postDownloadFile('api/ClientPages/ArchiveFolders', data, messageService);
    }

    public unpackLatestArchive(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/ClientPages/UnpackLatestArchive', data, messageService);
    }

    public scanAndPopulate(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/ClientPages/ScanAndPopulate', data, messageService);
    }

    public uploadArchiveFile(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/ClientPages/UploadArchiveFile', data, messageService);
    }

    public uploadArchiveChunk(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/ClientPages/UploadArchiveChunk', data, messageService);
    }

    public finalizeUpload(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/ClientPages/FinalizeUpload', data, messageService);
    }
}
